import { GraduationCap, Award, Trophy } from "lucide-react";

const PEGGY =
    "https://customer-assets.emergentagent.com/job_neuro-parents-test/artifacts/v2w82qy1_Peggy.JPG";
const DIDIER =
    "https://customer-assets.emergentagent.com/job_neuro-parents-test/artifacts/pxdt24n1_Didier.PNG";

const team = [
    {
        name: "Didier",
        role: "Expert en Neuroéducation",
        img: DIDIER,
        bio:
            "Entrepreneur et coach diplômé en neuroéducation. Applique les principes du stoïcisme au quotidien avec ses propres enfants. Accompagne parents, enfants et jeunes adultes vers l'autonomie et la réussite.",
        tags: [
            { icon: GraduationCap, label: "Diplômé en Neuroéducation" },
            { icon: Award, label: "Coach certifié" },
            { icon: Trophy, label: "Praticien du stoïcisme" },
        ],
    },
    {
        name: "Peggy",
        role: "Experte en Apprentissage",
        img: PEGGY,
        bio:
            "Entrepreneure certifiée en cartes heuristiques, spécialisée dans les nouvelles méthodes d'apprentissage. Accompagne également des sportifs dans la gestion de leur charge mentale et émotions.",
        tags: [
            { icon: GraduationCap, label: "Certifiée Cartes Heuristiques" },
            { icon: Award, label: "Spécialiste Apprentissage" },
            { icon: Trophy, label: "Coach Mental pour Sportifs" },
        ],
    },
];

export default function Experts() {
    return (
        <section
            id="experts"
            data-testid="experts-section"
            className="py-24 sm:py-32 bg-ink-50/40 relative"
        >
            <div className="container-wide">
                <div className="text-center max-w-2xl mx-auto">
                    <span className="eyebrow-brand">Vos experts</span>
                    <h2 data-testid="experts-title" className="display-2 mt-4">
                        Deux experts à vos côtés.
                    </h2>
                    <p className="body-lg mt-5">
                        Une approche complémentaire pour accompagner votre enfant vers la réussite.
                    </p>
                </div>

                <div className="mt-16 grid md:grid-cols-2 gap-8">
                    {team.map((m) => (
                        <article
                            key={m.name}
                            data-testid={`expert-card-${m.name.toLowerCase()}`}
                            className="soft-card overflow-hidden flex flex-col sm:flex-row items-start gap-6 sm:gap-8 p-7 sm:p-8 group transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-30px_rgba(20,184,166,0.35)]"
                        >
                            <div className="relative h-24 w-24 sm:h-28 sm:w-28 shrink-0 rounded-full overflow-hidden bg-ink-50 ring-4 ring-brand-50">
                                <img
                                    src={m.img}
                                    alt={`Portrait de ${m.name}`}
                                    className="w-full h-full object-cover object-[center_top] transition-transform duration-700 group-hover:scale-105"
                                />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h3 className="display-3">{m.name}</h3>
                                <p className="mt-1 text-brand-600 font-medium text-sm">{m.role}</p>
                                <p className="mt-4 text-ink-600 leading-relaxed text-sm sm:text-[15px]">{m.bio}</p>
                                <ul className="mt-5 flex flex-wrap gap-1.5">
                                    {m.tags.map(({ icon: Icon, label }) => (
                                        <li
                                            key={label}
                                            className="inline-flex items-center gap-1.5 text-[11px] font-medium px-2.5 py-1.5 rounded-full bg-brand-50 text-brand-700 border border-brand-100"
                                        >
                                            <Icon className="h-3 w-3" strokeWidth={2} />
                                            {label}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
